import React from "react"

import { AddressForm } from '../../forms'
import { isPrivateAddress } from '../../helpers/privateAddress.js'

const ProfileAddressForm = ({ user, authentication }) => {
    // A 🏠-labelled address is PRIVATE — never rendered on /profile.
    // EditView already hides the whole section; this guard keeps the rule
    // intact if this form is ever mounted from somewhere else.
    if (isPrivateAddress(user?.address)) {
        return null;
    }

    return (
        // Fontaine M56B: auto-save — same PUT /api/users/{id}/address, same
        // payload the Save button sent; the response still refreshes the
        // signed-in user through authentication.update().
        <AddressForm
            address={user.address}
            url={`/api/users/${user.id}/address`}
            autoSave
            afterSubmit={(user) => authentication.update(user)}
        />
    )
};

export default ProfileAddressForm;